import React from 'react';
import PageLayout from '../components/PageLayout';
import { Lock, Cookie, Eye, Database } from 'lucide-react';

function Section({ icon: Icon, title, children }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8">
      <div className="flex items-center gap-3 mb-3">
        <div className="h-10 w-10 rounded-lg bg-[#EAF5FE] text-[#0176D3] flex items-center justify-center">
          <Icon className="h-5 w-5" />
        </div>
        <h2 className="text-lg font-semibold text-[#032D60]">{title}</h2>
      </div>
      <div className="text-sm text-slate-700 dark:text-slate-300 leading-relaxed space-y-2">{children}</div>
    </div>
  );
}

export default function PrivacyPage() {
  return (
    <PageLayout>
      <section className="emi-wrap pt-8 pb-16">
        <div className="mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-[#032D60] tracking-tight">Privacy Policy</h1>
          <p className="mt-3 text-sm text-slate-500">Effective date: {new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</p>
          <p className="mt-3 text-sm sm:text-base text-slate-600 dark:text-slate-400 max-w-3xl leading-relaxed">
            EMIWise takes your privacy seriously. This page explains what we do (and do not) do with any information you provide while using the calculator.
          </p>
        </div>

        <div className="space-y-5">
          <Section icon={Database} title="What we collect">
            <p>
              The calculator runs entirely in your browser. Values you type — loan amount, interest rate, tenure, moratorium details, prepayments — are never sent to our servers. They only exist within your browser's memory for the duration of the session.
            </p>
            <p>
              We do store three lightweight preferences in your browser's local storage: language, currency and theme (light/dark). These stay on your device and can be cleared any time via your browser settings.
            </p>
          </Section>

          <Section icon={Cookie} title="Cookies">
            <p>
              EMIWise itself does not set any tracking cookies. If Google AdSense is enabled by the site operator, AdSense may set its own cookies for personalised advertising, subject to Google's privacy policy.
            </p>
          </Section>

          <Section icon={Eye} title="Analytics">
            <p>
              We do not run any third-party analytics scripts on this site. No pageviews or interaction data are collected or shared with any analytics service.
            </p>
          </Section>

          <Section icon={Lock} title="Your rights">
            <p>
              Since we do not store any personal information about you on our servers, there is nothing to request, export or delete from us. You have full control over the preferences stored locally in your browser.
            </p>
            <p>
              For any privacy-related questions, please reach out via the Contact page.
            </p>
          </Section>

          <div className="rounded-xl bg-[#EAF5FE] border border-[#B7E1FA] p-5 text-xs text-slate-700">
            <b>Disclaimer:</b> EMI figures produced by this calculator are illustrative estimates only. Actual loan terms, EMIs and interest outgo will depend on your lender's policies, fees and taxes.
          </div>
        </div>
      </section>
    </PageLayout>
  );
}
